interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
  className?: string;
}

export function Pagination({ page, totalPages, onChange, className = '' }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className={`flex items-center justify-end gap-3 text-xs text-ink-500 ${className}`}>
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page <= 1}
        className="disabled:opacity-30 hover:text-ink-900 px-1"
        aria-label="Previous page"
      >
        ‹
      </button>
      <span>
        Page {page} of {totalPages}
      </span>
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page >= totalPages}
        className="disabled:opacity-30 hover:text-ink-900 px-1"
        aria-label="Next page"
      >
        ›
      </button>
    </div>
  );
}
